<template>
  <Container :title="title" :subtitle="subtitle" @on-submit="$emit('on-submit')">
    <template #form>
      <v-form ref="form" @submit.prevent>
        <v-row>
          <v-col cols="12" v-for="pergunta in perguntas" :key="pergunta.id">
            <component
              :is="capitalizeText(pergunta.input)"
              :type="pergunta.type"
              :text="pergunta.text"
              :options="pergunta.options"
              :justify="pergunta.justify"
              :justify-all="pergunta.justifyAll"
              :required="pergunta.required"
              :no-required="pergunta.noRequired"
              :conditional-options="pergunta.conditionalOptions"
              v-model="respostas[pergunta.id]"
            />
          </v-col>
        </v-row>
      </v-form>
    </template>
  </Container>
</template>

<script>
import { capitalizeText } from '@/utils/formatter'

const Container = () => import('@/modules/FichaClinica/FichaClinicaContainer')
const Radio = () => import('@/modules/FichaClinica/FichaClinicaRadio')
const Textfield = () => import('@/modules/FichaClinica/FichaClinicaTextfield')
const Rating = () => import('@/modules/FichaClinica/FichaClinicaRating')
const Checkbox = () => import('@/modules/FichaClinica/FichaClinicaCheckbox')

export default {
  components: {
    Container,
    Radio,
    Textfield,
    Rating,
    Checkbox
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    perguntas: {
      type: Array,
      required: true
    },
    title: String,
    subtitle: String
  },
  data: () => ({
    capitalizeText
  }),
  computed: {
    respostas: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    }
  }
}
</script>
